import { truckerProfileApiService } from 'config/service';
import { TRiskManagementStatus } from 'constants/risk-management';
import { urls } from 'constants/urls';
import { IRiskManagementLastConsultationsResponse } from './types';

export const getRiskManagementLastConsultations = (
  truckerId: string,
  rmStatus: TRiskManagementStatus
): Promise<IRiskManagementLastConsultationsResponse> => {
  const url = `${urls.riskManagement.lastConsultations.replace(':truckerId', truckerId)}?status=${rmStatus}`;
  return truckerProfileApiService.get(url);
};
